<!-- Component can be used in microscope and periscope -->
<template>
  <div :class="{ card: true, inset: !!inset, 'no-padding': !!noPadding }" :aria-busy="loading || undefined">
    <AppProgressLinear v-if="loading" class="progress-linear" />
    <slot />
  </div>
</template>

<script setup lang="ts">
import AppProgressLinear from '../AppProgressLinear/AppProgressLinear.vue'

defineProps<{
  inset?: boolean
  noPadding?: boolean
  loading?: boolean
}>()
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  background-color: var(--color-canvas-default);
  border: 1px solid var(--color-border-default);
  border-radius: 6px;
  padding: 16px;

  // overflow: clip; Removed this because it caused aparment number suggestion list to get cut off, still keeping it here for reference if this causes any issues (2015-06-27)

  // Loading bar pinned flush to the very top edge, full width. Looks right on
  // no-padding cards (tables/lists); with padding it still hugs the top edge.
  .progress-linear {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }

  &.inset {
    background-color: var(--color-canvas-inset);
  }
  &.no-padding {
    padding: 0;
  }
}
</style>
